import store from "@/store";
import core from "@/core";
import { RouterBeforeTaskItem } from "@/router/router-before-task";

export default function() {
  return {
    data: () => ({
      backButton: {
        changed: false,
        routerBeforeTaskItem: null,
      },
    }),
    mounted() {
      const $this = this;
      const routerBeforeTask = store.state.routerBeforeTask;
      let allowBackCloseEvent = $this?.properties?.allowBackCloseEvent;
      if (allowBackCloseEvent == null) allowBackCloseEvent = true;
      this.backButton.routerBeforeTaskItem = new RouterBeforeTaskItem($this.$vnode.tag, () => {
        if ($this.backButton.changed) {
          if (document.querySelector(".back-alert") == null) {
            core.alert
              .show({
                title: "확인",
                body: "뒤로가시면 작성 하신 내용이 취소됩니다.<br>계속 진행하시겠습니까?",
                showCancelButton: true,
                confirmButtonText: "예",
                cancelButtonText: "아니오",
                allowBackCloseEvent: false,
                customClass: "back-alert",
              })
              .then((result) => {
                if (result === "confirm") {
                  $this.properties.visible = false;
                }
              });
          }
        } else if (allowBackCloseEvent) {
          $this.properties.visible = false;
        }
        return false;
      });
      routerBeforeTask.pushModal(this.backButton.routerBeforeTaskItem);
    },
    destroyed() {
      this.backButton.routerBeforeTaskItem.destroyed();
    },
  };
}
